export default "__VITE_ASSET__zQ_0MP76__"